import { FunctionComponent } from 'react'
import { Field as FormikField, FieldProps } from 'formik'
import {
  AutoComplete,
  AutoCompleteItem,
  Field
} from '@matillion/component-library'
import { useTranslation } from 'react-i18next'

import { resolveErrorText } from 'modules/Projects/AccessListing/EditUser/EditUser.util'
import classes from 'modules/Projects/AccessListing/EditUser/EditUser.module.scss'
import { availableRoleItems } from 'modules/Projects/AccessListing/AccessListing.util'

const Role: FunctionComponent = () => {
  const { t } = useTranslation()

  return (
    <FormikField name="role">
      {({ field, meta, form: { setFieldValue } }: FieldProps<string>) => (
        <div data-testid="select-role">
          <Field
            {...field}
            data-testid="select-role-input"
            className={classes.EditUser__Form__Field}
            title={t('accessListing.editUser.fields.role.title')}
            name="role"
            placeholder={t(
              'accessListing.editUser.fields.role.placeholderText'
            )}
            inputComponent={AutoComplete}
            availableItems={availableRoleItems}
            errorText={resolveErrorText(t, meta)}
            value={field.value || null}
            onChange={async (e: { target: AutoCompleteItem }) =>
              setFieldValue('role', e.target.value?.id)
            }
          />
        </div>
      )}
    </FormikField>
  )
}

export default Role
